"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _GRContent.GRContent;
  }
});
var _GRContent = require("./GRContent.styled");